import React from 'react';
import TotalToggle from 'pages/search/components/filters/modules/transient/total-toggle';
import { MonthlyAvailability } from './availability/MonthlyAvailability';
import useIsMobile from 'hooks/use-is-mobile';
import { FilterAmenity } from '../../filter-bases';
import { useSelector } from 'react-redux';
import dayjs from 'utils/dayjs-timezone';
import { FilterSpotSort } from '../transient/spot-sort';
export const FiltersMonthly = () => {
    const isMobile = useIsMobile();
    const monthlyStarts = useSelector((state) => state.searchRequest.starts);
    const timezone = useSelector((state) => state.city.data?.timezone);
    const monthlyStartsDayjs = dayjs(monthlyStarts);
    const dateDifference = monthlyStartsDayjs.diff(dayjs().tz(timezone), 'day');
    const showInstantAccessFilter = dateDifference < 5;
    return (<>
            <FilterSpotSort />
            {isMobile && <TotalToggle key="TotalToggle"/>}
            {showInstantAccessFilter && (<FilterAmenity key="InstantAccess" amenity="immediate-parking">
                    Instant Access
                </FilterAmenity>)}
            <FilterAmenity key="CoveredGarage" amenity="covered-parking">
                Covered Garage
            </FilterAmenity>
            <FilterAmenity key="SelfPark" amenity="self-park">
                Self Park
            </FilterAmenity>
            <MonthlyAvailability key="MonthlyAvailability"/>
            {!isMobile && <TotalToggle key="TotalToggle"/>}
        </>);
};
